const tabEquip = {
  equip: 'EQUIPO',
  service: 'SERVICIOS',
  action: 'ACCIONES',
  attachFiles: 'ARQUIVOS ADJUNTOS',
  maintenance: 'MANTENIMIENTO',
  equipFinance: 'FINANCIERO',
};

export default tabEquip;
